<lib-modal-layout [title]="'Update User'" [subtitle]="subtitle()">

  <p class="text-center mb-3">Enter the following details to update your user.</p>
  <form [formGroup]="editUserForm" (ngSubmit)="onSubmit()">
    <h5 class="text-left">User Information</h5>
    <div class="form-field-container">
      <div class="form-field">
        <lib-form-text
          label="First Name"
          formControlName="firstName">
        </lib-form-text>
      </div>
      <div class="form-field">
        <lib-form-text
          label="Last Name"
          formControlName="lastName">
        </lib-form-text>
      </div>
        <div class="form-field">
          <lib-form-text
            [readonly]="true"
            label="Email Address"
            formControlName="email">
          </lib-form-text>
        </div>
        <div class="form-field">
          <lib-form-phone
            label="Phone Number"
            formControlName="phone">
          </lib-form-phone>
        </div>
    </div>
    <h5 class="text-left">Agency Information</h5>
    <div class="flex items-center gap-4">
      <div class="form-field w-1/2">
        <lib-form-text
          [readonly]="true"
          label="Agency"
          formControlName="agency">
        </lib-form-text>
      </div>
      <div class="form-field w-1/2">
        <lib-form-dropdown 
          label="Role" 
          formControlName="role" 
          [options]="roles() || []"
        >
        </lib-form-dropdown>
      </div>
    </div>
    <h5 class="text-left">Settings</h5>
    <div class="flex items-center gap-4">
      <div class="form-field w-1/2">
        <lib-form-dropdown 
          label="Status" 
          formControlName="isActive" 
          [options]="[{ id: 'Active', name: 'Active' }, { id: 'Inactive', name: 'Inactive' }]"
        >
        </lib-form-dropdown>
      </div>
      <p class="flex items-center">Created Date: {{ this.data.createDate | date }}</p>
    </div>
    <div class="m-4">
      <lib-button [type]="'submit'" [text]="'Update User'" [disabled]="this.editUserForm.invalid"></lib-button>
    </div>
  </form>
</lib-modal-layout>